export const removeParamsFromUrl = (params) => {
  let url = window.location.href.split("?")[0] + "?";
  let pageURL = decodeURIComponent(window.location.search.substring(1));
  let urlVariables = pageURL.split("&");
  let parameterName;

  for (let i = 0; i < urlVariables.length; i++) {
    parameterName = urlVariables[i].split("=");

    if (!params.includes(parameterName[0])) {
      url = url + parameterName[0] + "=" + parameterName[1] + "&";
    }
  }

  return url.substring(0, url.length - 1);
};
